import Utils from "../utils";
import {
  AvailableProductResponse,
  MacrocategoriaProdotto,
  ProductPriceResponse,
  ProductVariants,
  VoceCosto,
} from "./product.models";

import { envConfig } from "../config/envconfig";

import { __, _x } from "@wordpress/i18n";

class ProductRenderers {
  constructor() { }

  emptyContainer(element: HTMLDivElement) {
    element.innerHTML = "";
  }

  /**
   * Gestisce visibilità degli elementi (flex)
   * @param elementSelector
   * @param visible
   */
  shouldShow(elementSelector: string, visible: boolean) {
    const element = document.querySelector(elementSelector);
    if (visible) {
      element.classList.remove("d-none");
      element.classList.add("d-flex");
    } else {
      element.classList.remove("d-flex");
      element.classList.add("d-none");
    }
  }

  handleScrollToItem = (target: HTMLElement) => {
    target.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };
  /**
   *
  /**
   * Mostra contenuti form di verifica copertura
   * @param element
   * @returns
   */
  renderCoverageForm(element: HTMLDivElement) {
    return new Promise<void>((resolve) => {
      element.innerHTML = /*html*/ `
      <div class="col-12 product-coverage-content">
        <h4 class="title uh-h4 text-center clr-absolute-white">
            ${element.dataset.label1}
        </h4>
        <div class="instructions mb-4 text-center uh-body-medium clr-secondary">
          ${element.dataset.label2}
        </div>
        <form class="coverage-form">
            <div>
                <input type="number" class="form-control" id="capInput"
                    placeholder="${element.dataset.label3}">
            </div>
            <div class="row check-button-container">
                <div class="col-12">
                    <button type="submit" id="sendCapButton" type="button"
                        class="cta-button button-primary__disabled uppercase w-100" disabled="true">
                        <span>${element.dataset.label4}</span>
                        <div class="spinner"></div>
                    </button>
                </div>
            </div>
        </form>
    </div>
      `;
      return resolve();
    });
  }

  // ---------------------------------------------------------
  // RESUME FUNCTIONS
  // ---------------------------------------------------------

  /**
   * Renderizza lista di voci di costo
   * @param items
   * @returns
   */
  renderBillItems(items: VoceCosto[] = [], iva: number): string {
    let htmlOut = "";
    items.push({descrizione:"IVA",prezzo:iva});
    items.forEach((item) => {
      htmlOut += /*html*/ `<div class="row pt-2">
      <div class="col-8 uh-body pb-1">${item.descrizione}</div>
        <div class="col-4 text-end">${Utils.floatToEuro(
        Number(item.prezzo)
      )} <super>€</super>
        </div>
      </div>`;
    });
    return htmlOut;
  }

  /**
   * Renderizza sezione di acquisto
   * @param item
   * @returns
   */
  renderBillBuySection(item: ProductPriceResponse, isNoSupply: boolean, macrocategoria: MacrocategoriaProdotto): string {
    const htmlOut = /*html*/ `<div class="row py-5 px-3">
    <div class="bill-total-border col-6 uh-body-big fw-bold pt-5 px-0">
      <span class='me-1'>
        ${__("Totale", "unipolhome")}
      </span>
      <span data-bs-toggle="tooltip" data-bs-placement="bottom" title="${php_pars?.products_tooltip[macrocategoria + '-' + (isNoSupply ? 'nofornitura' : 'fornitura')]}">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM11.2366 15.0532V13.9408C10.9166 13.9408 10.8266 13.846 10.8266 13.6821V9.7072H9.23665V13.8718C9.23665 14.7083 9.91665 15.0877 10.7766 15.0877C11.0266 15.0877 11.2366 15.0532 11.2366 15.0532ZM10.0273 6.00974C9.45892 6.00974 9.02734 6.45184 9.02734 7.00974C9.02734 7.57816 9.45892 8.00974 10.0273 8.00974C10.5852 8.00974 11.0273 7.57816 11.0273 7.00974C11.0273 6.45184 10.5852 6.00974 10.0273 6.00974Z" fill="#0F3250"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM11.2366 15.0532V13.9408C10.9166 13.9408 10.8266 13.846 10.8266 13.6821V9.7072H9.23665V13.8718C9.23665 14.7083 9.91665 15.0877 10.7766 15.0877C11.0266 15.0877 11.2366 15.0532 11.2366 15.0532ZM10.0273 6.00974C9.45892 6.00974 9.02734 6.45184 9.02734 7.00974C9.02734 7.57816 9.45892 8.00974 10.0273 8.00974C10.5852 8.00974 11.0273 7.57816 11.0273 7.00974C11.0273 6.45184 10.5852 6.00974 10.0273 6.00974Z" fill="#0F3250" fill-opacity="0.2"/>
        </svg>
      </span>
    </div>
    <div class="bill-total-border col-6 text-end uh-body-big fw-bold pt-5 px-0">${macrocategoria == 'installazione' ? __('Da definire', "unipolhome") : (Utils.floatToEuro(
      Number(item.prezzoTotale)
    ) + '<super>€</super>')}
    </div>
      </div>
      <div class="row">
          <div class="col-12">
              <a href="" id="buyButton-${isNoSupply ? 'variant' : 'main'}" type="button" class="cta-button button-primary uppercase w-100">
                  <span>${__("Prosegui", "unipolhome")}</span>
              </a>
          </div>
      </div>
      <div class="row py-3">
          <div class="col-12 text-center uh-body">
         ${php_pars.product_cancellazione_label}
          </div>
      </div>`;
    return htmlOut;
  }

  /**
   * Mostra container con risultato disponibilità POSITIVO popolandolo con UI
   * @param element
   * @param variants
   * @param userCap
   * @returns
   */
  renderResume(
    element: HTMLDivElement,
    variants: ProductVariants,
    userCap: string
  ) {
    return new Promise<void>((resolve) => {
      element.innerHTML = /*html*/ `
        <div class="col-12 product-resume-content px-5 px-md-4">
          <div class="row gy-3">
          ${variants.withoutSupply ? this.renderWithoutSupply(variants, true) : ''}
           ${variants.withSupply ? this.renderWithSupply(variants, !variants.withoutSupply) : ''}
            <div class="col-12 pr-bottom-container pt-2">
              <div class="row">
                <div class="col-12 uh-body text-center pb-1">
                  <a class="clr-secondary" href="#" id="reset-button">
                    ${userCap} ${element.dataset.label9}
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
        `;
      resolve();
    });
  }
  renderWithSupply(variants: ProductVariants, selected: boolean = false) {
    return /*html*/`
    <div id="resume-has-coverage" class="col-12 resume-top-container mb-3 py-5 ${selected ? 'opened' : ''}">
      <div class="row resume-top-content">
       <div class="col-12">
        <div class="row">
          <div class="col-6 uh-body-medium uh-fw-medium d-flex align-items-center ${!variants.withoutSupply ? 'd-none' : ''}">
            <input type="radio" id="has-coverage-true" name="has-coverage" value="${selected}" ${selected ? 'checked' : null}>
            <label for="has-coverage-true">
              ${__("Con fornitura", "unipolhome")}
            </label>
          </div>
          <div id="product-total-accordion-main" class="col-6 text-end uh-body-big uh-fw-bold ${selected ? 'd-none' : ''}">
          ${variants.macrocategoriaWithSupply == 'installazione' ? __("Da definire") : (Utils.floatToEuro(Number(variants.withSupply.prezzoTotale)) + "<super>€</super>")}
          </div>
        </div>
        <div class="row resume-items-list">
          <div class="col-12 gx-4 gy-2 px-4">
            ${variants.macrocategoriaWithSupply == 'installazione' ? '' : this.renderBillItems(variants.withSupply?.vociCosto, variants.withSupply?.ivaTotale)}
            ${variants.macrocategoriaWithSupply == 'installazione' ? this.renderInstallationLabels() : ''}

            ${this.renderBillBuySection(variants?.withSupply, false, variants.macrocategoriaWithSupply)}
          </div>
        </div>
      </div>
    </div>
    </div>
    `
  }
  renderWithoutSupply(variants: ProductVariants, selected: boolean = false) {
    return /*html*/`
    <div id="resume-hasnot-coverage" class="col-12 resume-top-container py-5 ${selected ? 'opened' : 'closed'}">
      <div class="row resume-top-content">
        <div class="col-12">
          <div class="row">
            <div class="col-6 uh-body-medium uh-fw-medium d-flex align-items-center ${!variants.withSupply ? 'd-none' : ''}">
              <input type="radio" id="has-coverage-false" name="has-coverage" value="${selected}" ${selected ? 'checked' : 'null'}>
              <label for="has-coverage-false">
                ${__("Senza fornitura", "unipolhome")}
              </label>
            </div>
            <div id="product-total-accordion-variant" class="col-6 text-end uh-body-big uh-fw-bold ${selected ? 'd-none' : ''}">
              ${variants.macrocategoriaWithoutSupply == 'installazione' ? __("Da definire") : (Utils.floatToEuro(Number(variants.withoutSupply.prezzoTotale)) + '<super>€</super>')}
            </div>
          </div>
          <div class="row resume-items-list">
            <div class="col-12 gx-4 gy-2">
              ${variants.macrocategoriaWithoutSupply != 'installazione' ? this.renderBillItems(variants.withoutSupply.vociCosto, variants.withoutSupply?.ivaTotale) : ''}
              ${variants.macrocategoriaWithoutSupply == 'installazione' ? this.renderInstallationLabels() : ''}
              ${this.renderBillBuySection(variants.withoutSupply, true, variants.macrocategoriaWithoutSupply)}
            </div>
          </div>
        </div>
      </div>
    </div>
    `
  }
  /**
   * Mostra container con risultato disponibilità NEGATIVO popolandolo con UI
   * @param element
   * @param productID
   * @param userCap
   * @returns
   */
  renderUnavailableContainer(
    element: HTMLDivElement,
    productID: string,
    userCap: string
  ) {
    return new Promise<void>((resolve) => {
      const privacy_link = new URL(location.protocol + '//' + location.host + php_pars.privacy_link);

      element.innerHTML = /*html*/ `
        <div class="col-12 product-notavailable-content">
            <div class="row py-3">
                <div class="col-12 d-flex justify-content-center pb-4">
                <img src="${window.php_pars.asset_path}/img/icon-hourglass.svg" width="24px" height="45px" alt="Non disponibile" />
                </div>
                <div class="col-12 ps-3 text-center clr-absolute-white text-uppercase uh-h4">
                  ${element.dataset.label2}
                </div>
            </div>
            <div class="row">
                <div class="col-12 text-center uh-body-medium">
                  ${element.dataset.label3}
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <hr>
                </div>
            </div>
            <div id="lead-title" class="row">
              <div class="col-12 uh-body text-center fw-bold pb-3">
                ${element.dataset.label4}
              </div>
            </div>
            <div id="lead-form"  class="row">
              <div class="col-12">
                <form class="email-form">
                  <div>
                      <input type="email" class="form-control" id="emailInput"
                          placeholder="${element.dataset.label5}">
                  </div>
                  <div class="row mt-3">
                <div class="d-flex flex-column align-items-start col-12">
                  <label class="mb-4">
                    <input type="checkbox" id="product-privacy-input" class="mt-1 me-1 coming-soon-privacy-input" />
                    <span class="uh-body-small"id="zipcode-privacy-html"></span>
                    </label>
                  <span id="product-no-privacy" class="zipcode-privacy-error d-none mb-2 uh-body-big">${php_pars.privacy_mandatory}</span>
                </div>
                      <div class="col-12">
                          <button type="submit" id="sendEmailButton" type="button"
                              class="cta-button button-primary uppercase w-100">
                            <span>${element.dataset.label6}</span>
                              <div class="spinner"></div>
                          </button>
                      </div>
                  </div>
                </form>
              </div>
            </div>
            <div ID="lead-button-container" class="row">
              <div class="col-12 uh-body text-center pb-3 pt-5">
                  <a class="clr-secondary" href="#" id="reset-button">${userCap} ${element.dataset.label7}</a>
                </div>
            </div>
        </div>
        `;
      resolve();
    });
  }
  /**
   * Mostra container con errore
   * @param element
   * @param productID
   * @param userCap
   * @returns
   */
  renderErrorContainer(
    element: HTMLDivElement
  ) {
    return new Promise<void>((resolve) => {

      element.innerHTML = /*html*/ `
        <div class="col-12 product-notavailable-content">
            <div class="row py-4">
                <div class="col-12 d-flex justify-content-center pb-5">
                  <img src="${window.php_pars.asset_path}/img/icon-error.svg" width="48px" height="48px" alt="Error" />
                </div>
                <div class="col-12 ps-3 text-center clr-absolute-white uh-h5">
                  ${element.dataset.label2}
                </div>
            </div>
            <div class="row pb-5 pt-1">
                <div class="col-12 text-center uh-body-medium">
                  ${element.dataset.label3}
                </div>
            </div>
            <div class="row">
              <div>
                <button type="button"
                    class="cta-button button-primary uppercase w-100" onClick="window.location.reload();">
                  <span>${element.dataset.label4}</span>
                  <div class="spinner"></div>
                </button>
              </div>
            </div>
            <div ID="lead-button-container" class="row">
              <div class="col-12 uh-body text-center pb-3 pt-5">
              ${element.dataset.label5}
                <a class="clr-secondary" href="${envConfig.SUPPORTPATH}/assistenza/contatti" id="reset-button">${element.dataset.label6}</a>.
              </div>
            </div>
        </div>
        `;
      resolve();
    });
  }
  /**
   * Mostra container con un messaggio per notificare in maniera  (quasi) gentile che il prodotto
   * non è attualmente configurato (nessun productid disponibile)
   * @param element
   * @returns
   */
  renderProductNotConfigured(
    element: HTMLDivElement) {
    return new Promise<void>((resolve) => {
      element.innerHTML = /*html*/ `
        <div class="col-12 product-not-configured-container w-100 d-flex  align-items-center pb-5">
            <div class="row py-3">
                <div class="col-12 d-flex justify-content-center pb-4">
                 <img src="${window.php_pars.asset_path}/img/icon-hourglass.svg"  alt="Non configurato" />
                </div>
                <div class="col-12 ps-3 text-center text-break clr-absolute-white uh-h5">
                  ${php_pars.product_not_configured_text}
                </div>
            </div>
        </div>
        `;
      resolve();
    });
  }
  /**
   * Mostra un messaggio di avvenuta raccolta della lead per cap non disponibile
   * @param element container prodotto
   * @returns
   */
  renderProductLeadTakenMessage(
    element: HTMLDivElement) {
    return new Promise<void>((resolve) => {
      element.innerHTML = /*html*/ `
            <p class="col-12 uh-body title-case uh-fw-medium text-break text-center">
              ${php_pars.lead_taken_title}
            </p>
            <p class="col-12 uh-body text-center text-break">
            ${php_pars.lead_taken_description}
            </p>
            <p class="col-12 uh-body text-break text-center">
            ${php_pars.lead_taken_description_bottom}
            </p>
          `;
      resolve();
    });
  }
  renderInstallationLabels(): string {
    return /*html*/`
    <div class="row pt-2">
      <div class="col-6 uh-body pb-1">${php_pars.post_info.post_title? php_pars.post_info.post_title : __("Sopralluogo", "unipolhome") }</div>
      <div class="col-6 text-end"><!-- <del><super>€</super>${__('50,00')}</del> --> <super>€</super><strong>0,00</strong></div>
    </div>
    <div class="row pt-2">
      <div class="col-12 uh-body pb-1">${php_pars.installation_description}</div>
    </div>
    `
  }
}

export default new ProductRenderers();
